import { routeMapping } from './router-config/routes-config';
import Vue from 'vue';
import Router from 'vue-router';
import { getCookie } from '~/utils/cookie';

Vue.use(Router);

// We'll use Vue Router's internal matching mechanism
let _router = null;

/**
 * Initializes a temporary router instance to use for path matching
 * We only create this once to avoid performance issues
 */
function getMatcherRouter() {
  if (_router) return _router;

  const routes = Object.entries(routeMapping).map(([route, subdomains]) => ({
    path: route,
    name: route.replace(/\//g, '_').replace(/^_/, '').replace(/:/g, '_'),
    meta: { subdomain: subdomains[0] }
  }));

  _router = new Router({
    mode: 'abstract', // Important: don't actually change the browser URL
    routes
  });

  return _router;
}

/**
 * Match a path against our routes and return the matched route if any
 * This handles dynamic segments like :id properly
 */
function getSubdomainForRoute(path) {
  try {
    const router = getMatcherRouter();
    const matched = router.match(path);

    if (matched && matched.meta && matched.meta.subdomain) {
      return matched.meta.subdomain;
    }

    // Custom matching for routes with dynamic segments
    for (const [route, subdomains] of Object.entries(routeMapping)) {
      // Handle [placeholder] syntax in routes (for customer IDs, etc.)
      if (route.includes('[')) {
        const regexPattern = '^' + route
          .replace(/\//g, '\\/') // Escape slashes
          .replace(/\[(\w+)\]/g, '([^/]+)'); // Replace [param] with regex group

        const regex = new RegExp(regexPattern);
        if (regex.test(path)) {
          return subdomains[0];
        }
      }
      // Handle colon syntax (for Vue Router style routes)
      else if (route.includes(':')) {
        const regexPattern = '^' + route
          .replace(/:[^/]+/g, '([^/]+)') // Replace :param with regex group
          .replace(/\//g, '\\/'); // Escape slashes

        const regex = new RegExp(regexPattern);
        if (regex.test(path)) {
          return subdomains[0];
        }
      }
      // Handle exact matches and subfolder paths
      else if (path === route || path.startsWith(route + '/')) {
        return subdomains[0];
      }
    }
  } catch (error) {
    console.error('Route matching error:', error);
  }

  // Default fallback
  return 'AM2';
}

const WHITELIST_ROUTES = [ // routes accessible without token
  '/message-preview/',
  '/authenticate/login',
  '/authenticate/signup',
  '/authenticate/forgot-password',
  '/authenticate/reset-password',
  '/authenticate/invite',
  '/authenticate/',
]

export default function (context) {

  // CHECK IF TOKEN HAD BEEN REMOVED BY ANOTHER TAB/SESSION
  const token = getCookie('x-auth-token');
  if (!token) {
    console.log('No token found, session has been closed in another tab, logging out!');
    if (!window.location.href.includes('/authenticate/login') && WHITELIST_ROUTES.every(w=>!window.location.href.includes(w))) {
      window.location.href = '/authenticate/login';
    }
    return false;
  }

  const { route, redirect } = context;
  const earlyAccessCookie= getCookie('am3EarlyAccessOptIn');
  console.log('AM2 ROUTE MIDDLEWARE | earlyAccessCookie:',  earlyAccessCookie);

  // Flag to track if we're redirecting
  let isRedirecting = false;

  console.log('AM2 ROUTE MIDDLEWARE | ENABLED_HYBRID_SETUP:',  process.env.ENABLED_HYBRID_SETUP);
  if (process.env.ENABLED_HYBRID_SETUP && earlyAccessCookie === 'true') {
    const subdomain = getSubdomainForRoute(route.path);
    const expectedHost = subdomain === 'AM2' ? process.env.AM2_SUBDOMAIN : process.env.AM3_SUBDOMAIN;

    console.log('AM2 ROUTE MIDDLEWARE', window.location.hostname + route.path, ' --> ', expectedHost + route.path );

    if (process.client && expectedHost && window.location.hostname !== expectedHost) {
      isRedirecting = true;
      return redirect(`${window.location.protocol}//${expectedHost}${route.fullPath}`, {external: true, replace: true});
    }
  }

  // Signal middleware completion if we're not redirecting
  if (process.client && !isRedirecting && typeof window !== 'undefined' && window.__resolveMiddlewarePromise) {
    // Use setTimeout to ensure this runs after the middleware completes
    setTimeout(() => {
      window.__resolveMiddlewarePromise();
      console.log('Route middleware completed');
    }, 0);
  }
}
